
import './App.css';
import Mainroutes from './pages/Mainroutes';



import PaymentSuccess from './pages/Payment/Paymentsucess';

function App() {
  return (
    <div className="App">
     <Mainroutes/>
     
       </div>
       );
  }
export default App
